import { z } from "zod/mini"

// Keep the legacy schema non-lossy; item-level link decoding lives in
// `codec/repeatable.ts`, where the field model is available.
export const RepeatableLegacySchema = z.array(z.unknown())

export type RepeatableLegacy = z.infer<typeof RepeatableLegacySchema>
